import * as React from 'react';

import { Bar } from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';

import {
    RewardsWrap,
    Rewards,
    Logos,
    RewardsDescription,
    Column,
    StyledButton,
} from './RewardsBanner.styled';

const RewardsBannerLoading = () => (
    <RewardsWrap data-testid="liquidity-rewards" aria-hidden="true" aria-busy="true">
        <Rewards>
            <Logos>
                <Bar $width="3.2rem" $height="3.2rem" $circle />
            </Logos>
            <RewardsDescription>
                <Column>
                    <Bar $width="12rem" $height="1.6rem" />
                    <span>
                        <Bar $width="16rem" $height="2.8rem" />
                    </span>
                </Column>
            </RewardsDescription>
            <StyledButton disabled>Claim All</StyledButton>
        </Rewards>
    </RewardsWrap>
);
export default RewardsBannerLoading;
